import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useCheckoutStoreContext } from '../../context';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import Text, { TEXT } from 'src/view/components/Text/Text';
import Textarea from '~/view/components/Controls/Textarea/Textarea';
import './style.scss';

const CheckoutNotes: React.FC = observer((): JSX.Element | null => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const onChange = useCallback((event: React.ChangeEvent<HTMLTextAreaElement>) => {
    checkoutStore.changeNotes(event.target.value);
  }, []);

  if (!appStore.settings?.order_notes) return null;

  return (
    <div className="d-flex align-items-start mb-3">
      <Text type={TEXT.ORDER_FIELD} text="Notes" className="mt-2" />
      <Textarea
        value={checkoutStore.params.notes}
        onChange={onChange}
        placeholder={localeStore.t('write_a_note')}
        maxLength={160}
        textAreaClassName="checkout-notes"
      />
    </div>
  );
});

export default CheckoutNotes;
